export const apiPath = '/v1/users';
const actionType = 'USER_FACILITIES';

export const assignedActionType = `${actionType}_ASSIGNED`;
export const unassignedActionType = `${actionType}_UNASSIGNED`;
export const bulkActionType = `${assignedActionType}`;
